module.exports = __webpack_public_path__ + "static/media/about1.fe2af8f0.png";